import StickyHeadTable from "./Devices";

export default StickyHeadTable;
